/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable indent */
/* eslint-disable @typescript-eslint/indent */
import IconProps, { StyledG } from './IconProps';

function DragHamburgerIcon(props: IconProps) {
	const { color = 'antracite' } = props;

	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12">
			<g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
				<StyledG color={color} fillRule="nonzero" transform="translate(-854 -516)">
					<path d="M866.35 522.667h-11.7A.658.658 0 01854 522c0-.368.29-.667.65-.667h11.7c.36 0 .65.299.65.667 0 .368-.29.667-.65.667zm0-5.334h-11.7a.658.658 0 01-.65-.666c0-.368.29-.667.65-.667h11.7c.36 0 .65.299.65.667 0 .368-.29.666-.65.666zm-11.7 9.334h11.7c.36 0 .65.298.65.666a.659.659 0 01-.65.667h-11.7a.659.659 0 01-.65-.667c0-.368.29-.666.65-.666z" />
				</StyledG>
			</g>
		</svg>
	);
}

export default DragHamburgerIcon;
